import { Box, Typography } from "@mui/material";
import { range } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { StrategyLegend } from "containers/StrategyPage/components/Legend";
import { ChartDisplayType } from "glue/Chart/chart.constants";
import { ChartTypeSwitch } from "legacyNext/components/Charts/ChartTypeSwitch";
import { useLegacyNextStore } from "legacyNext/store";
import { INITIAL_YEAR } from "legacyNext/types";

import { useAssetRiskChartData } from "./asset-risk.helpers";
import { AssetRiskStyles } from "./asset-risk.styles";
import { AssetRiskChartLine } from "./components/AssetRiskChartLine";
import { AssetRiskChartMark } from "./components/AssetRiskChartMark";
import { AssetRiskChartTooltip } from "./components/AssetRiskChartTooltip";

export const AssetRisk = () => {
    const { assetList } = useLegacyNextStore();

    const { t } = useTranslation();

    const [type, setType] = useState<ChartDisplayType>(
        ChartDisplayType.EMISSIONS
    );

    const { chartData, loading, pathways } = useAssetRiskChartData(
        assetList,
        type,
        t
    );

    const years = range(INITIAL_YEAR, 2050 + 1).map(
        (year) => new Date(year, 0, 1)
    );

    return (
        <Box>
            <Typography variant="h2">
                {t("legacyNext.marketBenchmark", "Markeds Benchmark")}
            </Typography>
            <Typography>
                {t(
                    "legacyNext.reductionAnalysisSubtitle",
                    "overview of how the property performs relative to the market. calculate and track the property's sustainability progress and view its footprint as either emissions or energy intensity."
                )}
            </Typography>
            <ChartTypeSwitch current={type} onChange={setType} />
            <AssetRiskStyles.LineChart
                xAxis={[
                    {
                        data: years,
                        min: new Date(INITIAL_YEAR, 0, 1),
                        max: new Date(2050, 0, 1),
                        scaleType: "time",
                        tickNumber: 5,
                        valueFormatter: (date) => date.getFullYear().toString(),
                    },
                ]}
                loading={loading}
                height={600}
                series={chartData}
                yAxis={[
                    {
                        tickNumber: 5,
                    },
                ]}
                tooltip={{
                    trigger: "item",
                }}
                axisHighlight={{ x: "none", y: "none" }}
                grid={{ vertical: true, horizontal: true }}
                slots={{
                    itemContent: AssetRiskChartTooltip,
                    line: AssetRiskChartLine,
                    mark: AssetRiskChartMark,
                }}
                slotProps={{
                    mark: {
                        series: chartData,
                        currentYearIndex: years.findIndex(
                            (year) =>
                                year.getFullYear() === new Date().getFullYear()
                        ),
                    } as any,
                    itemContent: { years } as any,
                    legend: { hidden: true },
                    line: { limit: new Date().getFullYear() } as any,
                }}
            />
            <StrategyLegend pathways={pathways} />
        </Box>
    );
};
